








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})

export default class VendorListDivider extends Vue {

    @Prop( { default:"" }) label!: string;

    mounted() : void {

    }

}

